import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Box } from "@mui/material";
import {MuiNavbar, MuiFeed, MuiVideo, MuiChannel, MuiSearch} from "./components";

const App = () => (
  <BrowserRouter>
    <Box sx={{ background: "#000000" }}>
      <MuiNavbar />
      <Routes>
        <Route path="/" exact element={<MuiFeed />} />
        <Route path="/video/:videoId" exact element={<MuiVideo />} />
        <Route path="/channel/:id" exact element={<MuiChannel />} />
        <Route path="/search/:searchItem" exact element={<MuiSearch />} />
      </Routes>
    </Box>
  </BrowserRouter>
);

export default App;
